<script setup>
import isEqual from 'lodash/isEqual';
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { Banner } from '@dashhudson/dashing-ui';
import { usePlatformConnection } from '@/composables/usePlatformConnection';
import { PLATFORM_CONNECTION } from '@/models/platform/platform-connection.enum';

const props = defineProps({
  platform: {
    type: Object,
    required: true,
    validator(value) {
      return Object.values(PLATFORM_CONNECTION).some((v) => isEqual(v, value));
    },
  },
});

const route = useRoute();
const platformConnection = usePlatformConnection();

const visible = computed(
  () => !route?.meta?.report && platformConnection.isNotConnected(props.platform),
);
const message = computed(
  () =>
    `Your ${props.platform.name} account has been disconnected. Please reconnect to receive up-to-date analytics on your page performance.`,
);
</script>

<template>
  <Banner
    v-if="visible"
    :message="message"
    :closable="false"
    title="Reconnect Account"
    call-to-action="Reconnect"
    severity="warn"
    @action="platformConnection.connect(props.platform)"
  />
</template>
